import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NamedLink } from '../../../../components';
import { createSlug } from '../../../../util/urlHelpers';
import css from './SectionTalentHero.module.css';
import { isArrayLength } from '../../../../util/genericHelpers';
import { STRING } from '../../../../util/constants';
import { UserType } from '../../../../util/enums';

const SectionAffiliationLinks = ({
  affiliationsOptions = [],
  listingCategory = UserType.TALENT,
}) => {
  // Returns a URL search query based on item type
  const getSearchQuery = item => {
    if (!item) return '';

    const categoryParam = `pub_listingCategory=${encodeURIComponent(listingCategory)}`;

    // If item is a plain string => treat as organization
    if (typeof item === STRING) {
      return `pub_affiliatedOrganizations=has_any:${encodeURIComponent(item)}&${categoryParam}`;
    }

    // If item has a key => treat as division
    if (item.key) {
      return `pub_division=${encodeURIComponent(item.key)}&${categoryParam}`;
    }

    // If item has a conference => treat as conference
    if (item.conference) {
      return `keywords=${encodeURIComponent(item.conference)}&${categoryParam}`;
    }

    // Otherwise no search query (e.g., an agency with an ID will use ListingPage)
    return '';
  };

  // Returns display text for the link
  const getDisplayText = item => {
    if (!item) return '';
    if (typeof item === STRING) return item; // customAffiliations, etc.
    if (item.name) return item.name; // e.g., pub_agency
    if (item.conference) return item.conference; // e.g., conference object
    if (item.value) return item.value; // e.g., item with key/value
    return '';
  };

  // Filter valid affiliations to avoid rendering empty items
  const validAffiliations = affiliationsOptions.filter(item => {
    const displayText = getDisplayText(item);
    return !!displayText;
  });

  return (
    <div className={css.keywordSec}>
      <h2>
        <FormattedMessage id="SectionHero.affiliations" />
      </h2>
      <div className={css.keywords}>
        {isArrayLength(validAffiliations) &&
          validAffiliations.map((item, index) => {
            // If item has an ID, link to ListingPage; otherwise, link to SearchPage
            const hasId = !!(item && item.id);
            const linkName = hasId ? 'ListingPage' : 'SearchPage';
            const linkParams = hasId ? { slug: createSlug(item.name), id: item.id } : {};
            const linkTo = hasId ? {} : { search: getSearchQuery(item) };

            // Use stable key: prefer id for objects, the string itself for strings, fallback to index
            const key = item?.id || (typeof item === STRING ? item : index);

            return (
              <NamedLink
                className={css.affiliationLink}
                key={key}
                name={linkName}
                to={linkTo}
                params={linkParams}
              >
                <strong className={css.affiliation}>{getDisplayText(item)}</strong>
              </NamedLink>
            );
          })}
      </div>
    </div>
  );
};

export default SectionAffiliationLinks;
